var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"r6-navigation",attrs:{"aria-label":_vm.$t('cyberboardR6.title')}},_vm._l((_vm.items),function(item){return _c('router-link',{key:item.path,staticClass:"item",attrs:{"to":{
      path: item.path,
      query: {
        light:
          _vm.lightPosition === null
            ? _vm.$route.query.light
            : String(_vm.lightPosition + 1),
      },
    },"exact":""}},[_c('i',{staticClass:"iconfont iconarrow-right"}),_c('span',{staticClass:"navigation-label px"},[_vm._v(_vm._s(item.label))])])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }